import * as CryptoJS from 'crypto-js'

/**
 * 修改记录:
 * 19-07-18       张发勇          首次提交
 */

/**
 * cx.security.encrypt
 * 加密类
 *
 * @class
 * @memberof    cx.security
 */

class Encrypt
{
  /**
   * 数据加密
   * @static
   * @method
   * @param   {String}    code          源码
   * @param   {String}    secretKey     加密码
   * @param   {String}    type          加密方式(DES ..)
   * @returns {String}                  加密后的串
   */
  static encrypt(code, secretKey, type)
  {
    return CryptoJS.DES.encrypt(code, CryptoJS.enc.Utf8.parse(secretKey),
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      }).toString()
  }

  /**
   * 解密字符串
   * @static
   * @method
   * @param   {String}    str               待加密的字符串
   * @param   {String}    secretKey         安全key
   * @returns {String}                      加密后的字符串
   */
  static decrypt(str, secretKey)
  {
    return CryptoJS.DES.decrypt(
      { ciphertext: CryptoJS.enc.Base64.parse(str) },
      CryptoJS.enc.Utf8.parse(secretKey),
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      }).toString(CryptoJS.enc.Utf8)
  }
}

Encrypt.CryptoJS = CryptoJS
export default Encrypt



// WEBPACK FOOTER //
// ./src/plugins/app/layout/Encrypt.js